import styles from "./styles.module.scss";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import ScheduleModal from "app/components/SpaceTabsContainer/ScheduleModal";
import CalendarIco from "../../../public/images/calendar-ico.svg";
import usga_logo from "../../../public/usga_logo_big.png";

type TabType = 'bookings' | 'scores&stats';

interface Props {
  athleteData: any;
  isUSGAIntegrationActive: boolean;
}

const SpaceMenu = ({athleteData, isUSGAIntegrationActive }: Props) => {
  const { t } = useTranslation();
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const[modalTab, setModalTab] = useState<TabType>(null);

  const scheduleModalHandler = () => {
    setIsScheduleModalOpen((prev) => !prev);
  };

  const openModal = (tabType: TabType) => {
    setModalTab(tabType);
    scheduleModalHandler();
  };

  return (
    <>
      <ul className={styles.dropdown_list}>
        {isUSGAIntegrationActive && (
          <li onClick={() => openModal('scores&stats')} className={styles.scores_stats}>
            <img src={usga_logo} alt="USGA logo" />
            {t("Scores & Stats")}
          </li>
        )}
        <li onClick={() => openModal('bookings')}>
          <img src={CalendarIco} alt="calendar" className={styles.calendar_ico} />
          {t("Bookings")}
        </li>
        {/*<li onClick={null}>{t("Purchases")}</li>*/}
      </ul>

      {isScheduleModalOpen && (
        <ScheduleModal
          isModalOpen={isScheduleModalOpen}
          modalHandler={scheduleModalHandler}
          athleteData={athleteData}
          tabType={modalTab}
          isUSGAIntegrationActive={isUSGAIntegrationActive}
        />
      )}
    </>
  );
};

export default SpaceMenu;
